<sysque-frame [componentTitle]="componentTitle">
  @if (!isManageMode) {
    <sysque-add-fitting-mode (notifyDoneClick)="onDoneClick()"></sysque-add-fitting-mode>
  }

  @if (isManageMode) {
    <sysque-manage-mode (notifyDoneClick)="onManageModeDoneClick()"></sysque-manage-mode>
  }
</sysque-frame>
